#import "../../../../timeline/graphql/fragments/session-fragment.graphql"

query GetMcfxCompanySessions($id: ID!) {
    sessions(mcfxCompanyId: $id) {
        ...SessionFragment
    }
}
